import { RightOutlined, CloseOutlined, CheckOutlined } from "@ant-design/icons";
import AvatarWithInitials from "./AvatarWithInitials";
import TooltipTag from "./TooltipTag";
import { labelRender } from "../../views/DataDiscrepancies/Components";

type AvatarConfig = {
  avatarSize?: number;
  avatarFontSize?: number;
  labelFontSize?: number;
};

type StatusTransitionProps = {
  type:
    | "discrepancy_assignee"
    | "discrepancy_status"
    | "discrepancy_resolution_status";
  fromValue?: string | null;
  toValue?: string | null;
  avatarConfig?: AvatarConfig;
};

const StatusTransition = ({
  type,
  fromValue,
  toValue,
  avatarConfig,
}: StatusTransitionProps) => {
  const defaultAvatarConfig = {
    avatarSize: 25,
    avatarFontSize: 10,
    labelFontSize: 14,
  };

  const finalAvatarConfig =
    type === "discrepancy_assignee" && avatarConfig
      ? { ...defaultAvatarConfig, ...avatarConfig }
      : defaultAvatarConfig;

  return (
    <div className="flex gap-2 items-center">
      {type === "discrepancy_assignee" && (
        <>
          <AvatarWithInitials
            name={fromValue || "Unassigned"}
            avatarSize={finalAvatarConfig.avatarSize}
            avatarFontSize={finalAvatarConfig.avatarFontSize}
            labelFontSize={finalAvatarConfig.labelFontSize}
          />
          <RightOutlined className="text-[#00000073] text-xs" />
          <AvatarWithInitials
            name={toValue || "Unassigned"}
            avatarSize={finalAvatarConfig.avatarSize}
            avatarFontSize={finalAvatarConfig.avatarFontSize}
            labelFontSize={finalAvatarConfig.labelFontSize}
          />
        </>
      )}

      {type === "discrepancy_status" && (
        <>
          {labelRender({
            label: fromValue || "Empty",
          })}
          <RightOutlined className="text-[#00000073] text-xs" />
          {labelRender({
            label: toValue || "Empty",
          })}
        </>
      )}

      {type === "discrepancy_resolution_status" && (
        <>
          <TooltipTag
            tagColor="#0000000f"
            textColor="#2B4752"
            icon={<CloseOutlined style={{ color: "#2B4752" }} />}
            tagStyle={{ borderRadius: "4px" }}
            tooltipTitle={fromValue}
          >
            {fromValue || "Unknown"}
          </TooltipTag>
          <RightOutlined className="text-[#00000073] text-xs" />
          <TooltipTag
            tagColor="#BDE0CC"
            textColor="#003832"
            icon={<CheckOutlined style={{ color: "#003832" }} />}
            tagStyle={{ borderRadius: "4px" }}
            tooltipTitle={toValue}
          >
            {toValue || "Unknown"}
          </TooltipTag>
        </>
      )}
    </div>
  );
};

export default StatusTransition;
